import { createCrudActions } from '../utils/crudGenerator';

const formatSpecialdays = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchSpecialdays,
    create: createSpecialday,
    update: updateSpecialday,
    delete: deleteSpecialdays
} = createCrudActions('SPECIALDAY', "Especiale", formatSpecialdays);